export const noop = (..._args: unknown[]) => {
}

export const MAX_WINDOW_WIDTH = 1280